<template>
  <div class="pagination">
    <button
      type="button"
      class="btn btn-sm"
      :disabled="isFirstPage"
      @click="go(1)"
    >
      第一頁
    </button>
    <button
      type="button"
      class="btn btn-sm"
      :disabled="isFirstPage"
      @click="go(page - 1)"
    >
      上一頁
    </button>
    <span class="page-info">{{ pageInfoText }}</span>
    <button
      type="button"
      class="btn btn-sm"
      :disabled="isLastPage"
      @click="go(page + 1)"
    >
      下一頁
    </button>
    <button
      type="button"
      class="btn btn-sm"
      :disabled="isLastPage"
      @click="go(safeTotalPages)"
    >
      最後一頁
    </button>
  </div>
</template>

<script>
export default {
  name: 'ListPagination',
  props: {
    page: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      default: null
    }
  },
  emits: ['change'],
  computed: {
    safeTotalPages() {
      const pages = Number(this.totalPages);
      if (!Number.isFinite(pages) || pages < 1) {
        return 1;
      }
      return pages;
    },
    isFirstPage() {
      return this.page <= 1;
    },
    isLastPage() {
      const pages = Number(this.totalPages);
      if (!Number.isFinite(pages) || pages <= 1) {
        return true;
      }
      return this.page >= pages;
    },
    pageInfoText() {
      const text = `第 ${this.page} 頁，共 ${this.safeTotalPages} 頁`;
      if (this.total == null) {
        return text;
      }
      return `${text}（總計 ${this.total} 筆）`;
    }
  },
  methods: {
    go(targetPage) {
      if (targetPage < 1 || targetPage > this.safeTotalPages || targetPage === this.page) {
        return;
      }
      this.$emit('change', targetPage);
    }
  }
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.page-info {
  color: #666;
  font-size: 14px;
}
</style>
